import type { ReactNode } from 'react';
import { cn } from '@shared/lib/utils';

export type DashboardCardRowProps = {
  children: ReactNode;
  columns?: 1 | 2 | 3 | 4;
  className?: string;
};

const columnClasses: Record<NonNullable<DashboardCardRowProps['columns']>, string> = {
  1: 'md:grid-cols-3',
  2: 'md:grid-cols-3',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
};

export function DashboardCardRow({ children, columns = 4, className }: DashboardCardRowProps) {
  return (
    <div
      className={cn('grid grid-cols-1 items-stretch gap-3', columnClasses[columns], className)}
      data-testid="dashboard-card-row"
    >
      {children}
    </div>
  );
}
